// @flow
export const ErrorPagesLocale = {
  title: ["Page Not Found", "Sayfa Bulunamadı"],
  content: ["Seems like you're looking for something that doesn't exist.", "Aradığınız sayfa sistemimizde bulunmuyor."],
  goback: ["GO BACK", "GERİ DÖN"],
  homepage: ["RETURN TO HOMEPAGE", "ANASAYFA'YA DEVAM ET"]
};



// WEBPACK FOOTER //
// ./src/Locales/ErrorPages/ErrorPages.locale.js